import { TokenStorage } from "../types/users/TokensResponse";

export const getTokenFromStorage = (): TokenStorage => {
  return {
    token: localStorage.getItem("snet.auth.token"),
    usuarioId: localStorage.getItem("snet.auth.usuarioId")
  };
};

export const setStorageToken = (token : string, usuarioId: string | null) => {
  if (!token) {
    return;
  }
  localStorage.setItem("snet.auth.token", token);
  if (usuarioId !== null) {
    localStorage.setItem("snet.auth.usuarioId", usuarioId);
  }
};

export const removeStorage = () => {
  localStorage.removeItem("snet.auth.token");
  localStorage.removeItem("snet.auth.usuarioId");
};